/**
 * ACTIONS TYPES
 */
export enum CartTypes {
  ADD = '@repositories/ADD',
  DROP = '@repositories/DROP',
  UPDATE = '@repositories/UPDATE',
  CLEAN = '@repositories/CLEAN'
}

export interface ProductType {
  rowid?: string;
  codigo: number;
  nome: string;
  priceOrigin?: number;
  price: number;
  qty: number;
  foto?: string;
  estoque?: number;
  altura?: number;
  largura?: number;
  comprimento?: number;
  peso?: number;
}

/**
 * Data types
 */
export interface Cart {
  produtos: Array<ProductType>
}

/**
 * State types
 */
export interface CartState {
  readonly data: Cart
}